/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { QueryClient } from "@tanstack/react-query";

const defaultOptions = {
  defaultOptions: {
    queries: {
      retry: false,
    },
  },
};

export function createQueryClient() {
  return new QueryClient(defaultOptions);
}

let _activeQueryClient = null;

export function setActiveQueryClient(client) {
  _activeQueryClient = client;
}

export function getActiveQueryClient() {
  if (!_activeQueryClient) {
    console.warn("No active client set yet");
  }
  return _activeQueryClient;
}
